module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAG0lEQVQ4jWMICgraQClmGDVk1JBRQ0YNCdoAAHYawHDC5WlcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./es6/admin-common-js/legacy/vendor/facebox/b.png
// module id = 575
// module chunks = 7 8 9 10